var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2639 8.08012V10H2.86364C2.55468 9.35285 3.29989 8.71803 4.2709 8.08012H7.2639Z",
    fill: "#567A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64131 2.69337C8.01487 4.77843 -3.80169 7.17843 2.45681 9.99877C1.32076 7.61356 12.9038 5.37874 7.64131 2.69337Z",
    fill: "#567A9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86048 3.91186C5.60397 3.95439 5.44022 3.92173 5.44022 3.92173C5.35194 3.89029 5.26367 3.85763 5.14085 3.81387L2.32504 2.55778V0L7.13277 2.5017C7.18459 2.53374 7.23704 2.57196 7.25175 2.62558C7.37904 3.09091 6.40867 3.82188 5.86048 3.91186Z",
    fill: "#567A9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94743 5.102C3.4074 5.102 3.78028 4.74273 3.78028 4.29954C3.78028 3.85635 3.4074 3.49707 2.94743 3.49707C2.48747 3.49707 2.11459 3.85635 2.11459 4.29954C2.11459 4.74273 2.48747 5.102 2.94743 5.102Z",
    fill: "#567A9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5426 9.85948C9.00257 9.85948 9.37544 9.5002 9.37544 9.05701C9.37544 8.61382 9.00257 8.25455 8.5426 8.25455C8.08263 8.25455 7.70975 8.61382 7.70975 9.05701C7.70975 9.5002 8.08263 9.85948 8.5426 9.85948Z",
    fill: "#567A9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZAi);
export default __webpack_public_path__ + "static/media/z_ai.64e0e12862ea04c7a9b9128415efcd32.svg";
export { ForwardRef as ReactComponent };